import { render, staticRenderFns } from "./EditLegalPerson.vue?vue&type=template&id=f162508a&"
import script from "./EditLegalPerson.vue?vue&type=script&lang=js&"
export * from "./EditLegalPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports